export const langs= {
    en: 'English',
    it: 'Italian',
    de: 'German',
    fr: 'French',
    es: 'Spanish'
}